import { ChangeEvent, FC } from 'react';
import { CheckboxInputProps } from '@/components/functional/CheckboxInput/CheckboxInput.tsx';
import { cn } from '@/utils/classNames.ts';

const CheckboxInputBlock: FC<CheckboxInputProps> = ({
  onChange,
  checked,
  value,
  label,
  className,
  error,
  type = 'checkbox',
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
  };

  return (
    <label
      className={cn(
        'input input-bordered flex justify-center text-center items-center gap-4 h-auto min-h-12 cursor-pointer',
        {
          'border-primary bg-journi-theme-light': checked,
          'input-error': !!error,
        },
        className
      )}
    >
      <div className="text-sm">{label}</div>
      <input type={type} className="hidden" onChange={handleChange} checked={checked} value={value} />
    </label>
  );
};

export default CheckboxInputBlock;
